export class FFmpegConfBase<T> {
  value: T | undefined;
  // 配置别名
  alias: string;
  // ffmpeg exec cmd
  cmd: string;
  // codec
  // 可选值: libx264, libx265
  // TIPS.
  //   使用 libx264
  // 格式化: ` -c:v ${codec} `
  codec: string;
  // constant rate factor
  // 可选值: 17 ~ 30
  // TIPS.
  //   RF 18-22 for 480p/576p Standard Definition, 推荐 20
  //   RF 19-23 for 720p High Definition
  //   RF 20-24 for 1080p Full High Definition, 推荐 22
  //   RF 22-28 for 2160p 4K Ultra High Definition, 推荐 24
  // 格式化: ` -crf ${constantRateFactor} `
  constantRateFactor: number;
  // optimising compression and encoding settings
  // 可选值:
  //   ultrafast, superfast, veryfast, faster, fast,
  //   medium,
  //   slow, slower, veryslow, placebo
  // TIPS.
  //   选择越快的配置组，编码时间越短，编码质量越低
  //   一般推荐 medium
  // 格式化: ` -preset ${preset} `
  preset: string;
  // resolution
  // 可选值: 480, 720, 1080
  // TIPS.
  //   scale 常见用法为 -vf scale=1280:720 (height: 720, width: 1280)
  //   为保持画面比例，这里使用 -vf scal=-2:720 (height: 720, width: auto)
  // 格式化: ` -vf scale=-2:{resolution}`
  resolution: string;
  // video bitrate
  // 可选值(kbps):
  //   1000, 2500, 5000, 8000
  // TIPS.
  //   YouTube 建议值
  //   Type     standard Frame Rate     High Frame Rate
  //   360p     1000 kbps               1500 kbps
  //   480p     2500 kbps               4000 kbps
  //   720p     5000 kbps               7500 kbps
  //   1080p    8000 kbps               12000 kbps
  // 格式化: ` -b:v ${videoBitrate}k `
  videoBitrate: string;
  // audio bitrate
  // 可选值(kbps):
  //   32, 96, 128, 256
  // TIPS.
  //   参考 MP3 标准
  //   Type             Usage
  //   32 kbps          MW (AM): 语音
  //   96 kbps          FM: 语音/低质量流媒体
  //   128 ~ 160 kbps   中等质量
  //   192 kbps         中等质量
  //   256 kbps         高等质量
  //   320 kbps         MP3 支持最高值
  // 格式化: ` -b:a ${audioBitRate} `
  audioBitrate: string;
  // frame rate
  // 可选值:
  //   24, 30, 48, 60
  // TIPS.
  //   参考标准
  //   Type
  //   film      24
  //   标准帧率    24, 25, 30
  //   高帧率     48, 50, 60
  // 格式化: ` -r ${frameRate} `
  frameRate: string;

  constructor(args: {
    value?: T;
    alias?: string;
    cmd?: string;
    codec?: string;
    constantRateFactor?: number;
    preset?: string;
    resolution?: string;
    videoBitrate?: string;
    audioBitrate?: string;
    frameRate?: string;
  } = {}) {
    this.value = args.value;
    this.alias = args.alias;
    this.cmd = args.cmd;
    this.codec = args.codec;
    this.constantRateFactor = args.constantRateFactor;
    this.preset = args.preset;
    this.resolution = args.resolution;
    this.videoBitrate = args.videoBitrate;
    this.audioBitrate = args.audioBitrate;
    this.frameRate = args.frameRate;
  }

  public getCmd = (inputName: string, outputName: string): Array<string> => {
    const _cmd: string = this.cmd
      ? this.cmd
      : this._genCmd(inputName, outputName);
    return _cmd.trim().split(/ +/);
  }

  private _genCmd = (inputName: string, outputName: string): string => {
    // let _cmd: string = '';
    let options = '';
    if (this.codec) {
      options += ` -c:v ${this.codec} `;
    }
    if (this.constantRateFactor) {
      options += ` -crf ${this.constantRateFactor} `;
    }
    if (this.preset) {
      options += ` -preset ${this.preset} `;
    }
    if (this.resolution) {
      options += ` -vf scale=-2:${this.resolution} `;
    }
    if (this.frameRate) {
      options += ` -r ${this.frameRate} `;
    }
    if (this.videoBitrate) {
      options += ` -b:v ${this.videoBitrate}k `;
    }
    if (this.audioBitrate) {
      options += ` -b:a ${this.audioBitrate}k `;
    }

    return (inputName && outputName)
      ? `-i ${inputName} ${options} ${outputName}`
      : `${options}`;
  }

  public getValue = () => {
    const properties = ['alias', 'cmd', 'codec', 'constantRateFactor',
      'preset', 'resolution', 'videoBitrate', 'audioBitrate', 'frameRate'];
    return properties.reduce((previousValue, currentValue) => {
      if (this[currentValue] !== undefined) {
        previousValue[currentValue] = this[currentValue];
      } else {
        previousValue[currentValue] = null;
      }
      return previousValue;
    }, {});
    // return {
    //   alias: this.alias,
    //   cmd: this.cmd,
    //   codec: this.codec,
    //   constantRateFactor: this.constantRateFactor,
    //   preset: this.preset,
    //   resolution: this.resolution,
    //   videoBitrate: this.videoBitrate,
    //   audioBitrate: this.audioBitrate,
    //   frameRate: this.frameRate
    // };
  }
}
